import { getCustomerId } from 'redux/modules/sessions/selectors';

export const addPromoCode = (state, action) => {
  return {
    customerId: getCustomerId(state),
    event: 'promo_code_added',
    promoCode: { result: action.promoCode },
    status: action.promoCode.status || action.result.status || '',
  };
};

export const removePromoCode = (state, action) => ({
  customerId: getCustomerId(state),
  event: 'promo_code_removed',
  promoCode: action.promoCode,
  result: action.result,
});

export const addPromoCodeApiError = (state, action) => ({
  customerId: getCustomerId(state),
  event: 'promo_code_api_error',
  promoCode: action.code,
  error: action.error,
  method: 'POST',
});

export const removePromoCodeApiError = (state, action) => ({
  customerId: getCustomerId(state),
  event: 'promo_code_api_error',
  promoCode: action.promoCode,
  error: action.error,
  method: 'DELETE',
});
